import { render, staticRenderFns } from "./ResultsFilter.vue?vue&type=template&id=b6621b5c&"
import script from "./ResultsFilter.vue?vue&type=script&lang=ts&"
export * from "./ResultsFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports